/**
 * Elevate Your Journey — full-bleed marketing section replacing the retired
 * campaign panel. Focuses on executive travel, special events, and bespoke
 * luxury itineraries. Whole panel is a `tel:` link so a tap opens the
 * dialer on mobile.
 */
export default function ElevateJourneyBanner() {
  return (
    <section
      data-testid="home-elevate-journey"
      className="relative border-t border-white/10 border-b bg-[#0B0B0C]"
    >
      <a
        href="tel:+13475230763"
        data-testid="elevate-journey-tap"
        className="block w-full group focus:outline-none focus:ring-1 focus:ring-[#C5A24A]/60"
        aria-label="Elevate Your Journey — Executive travel, special events, and luxury itineraries. Call Phantasm Limousine."
      >
        <div className="relative w-full max-w-[1400px] mx-auto">
          <img
            src="/assets/sections/travel_2.jpeg"
            alt="Luxury fleet Cadillac Escalade with professional chauffeur at Boston Marriott — hourly charter service"
            className="block w-full h-auto object-contain mx-auto transition-opacity duration-300 group-hover:opacity-95"
            loading="lazy"
            draggable={false}
          />
          <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-[#0B0B0C]/70 via-transparent to-transparent" aria-hidden />
          <div className="absolute bottom-0 left-0 right-0 px-6 md:px-14 py-10 md:py-16 text-center pointer-events-none">
            <div className="text-[10px] uppercase tracking-[0.4em] text-[#C5A24A] mb-4">
              Beyond the Reservation
            </div>
            <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.05] mb-5">
              Elevate Your Journey
            </h2>
            <p className="mx-auto max-w-2xl text-sm md:text-base text-[#E6E6E6] font-light leading-relaxed">
              Executive travel, special events, and bespoke luxury itineraries —
              refined transportation for the modern discerning traveler.
            </p>
          </div>
        </div>
      </a>
    </section>
  );
}
